import React, { useRef,useContext,useEffect } from 'react';
import { useUserAPI } from '../../components/useUserAPI';
// import { QRCodeComponent } from '../../components/QRCodeComponent';
import { SharedInfoContext } from '../../components/SharedInfoContextProvider';
// import { ShoppingStart } from '../../components/ShoppingStart';
// import { iAeonSetData } from '../../library/iaeon_sdk.js';
import Lottie from 'react-lottie';
import animationData from '../../images/front_check_sp';

import styles from '../../styles/Checkout.module.scss';

export function FrontCheck(props) {


const { getdammingcheckresultAPI, data: getdammingcheckresultData, loading: getdammingcheckresultLoading, error: getdammingcheckresultError } = useUserAPI();
const { dammingCheckRunInterval, updateDammingCheckRunInterval } = useContext(SharedInfoContext);

useEffect(() => {
	document.body.classList.add('bg_white');
	document.getElementById('header').classList.remove('is_fixed');
	document.getElementById('header').classList.add('is_behind');

	// setTimeout(function(){
	// 	goRegi();
	// }, 3000);

	const dammingInterval = dammingCheckRunInterval * 1000;
	setTimeout(function(){
		getdammingcheckresultAPI(props.shoppingStData.data.transactionno);
	}, dammingInterval);

	//高さ調整：arrows We 対応
	if(window.innerWidth >= 320){
		document.documentElement.style.zoom = window.innerWidth / 390;
		var zratio = window.innerWidth / 390;
	}else{
		document.documentElement.style.zoom = 1;
		var zratio = 1;
	}
	let hratio = window.innerHeight / (window.innerHeight * zratio);
	let realheight = window.innerHeight * hratio;
	let elementA = document.getElementById('regiFrame');
	if (elementA) {
		elementA.style.height = realheight + 'px';
	}
}, []);

const lottieRef = useRef(null);

const defaultOptions = {
    renderer: 'svg',
    loop: true,
    autoplay: true,
	animationData: animationData
};

const goRegi = () => {
	props.setPage(props.regiType);
}


useEffect(() => {
	// console.log("useEffect purchaseData");
	if(getdammingcheckresultData){
		if (getdammingcheckresultData.data) { //SUCCESS
			console.log(`【getdammingcheckresultAPI】 dammingCheckResult: ${getdammingcheckresultData.data.dammingCheckResult}`);

			if(getdammingcheckresultData.data.dammingCheckResult === "0" || getdammingcheckresultData.data.dammingCheckResult === 0){ //NG
				const dammingInterval = dammingCheckRunInterval * 1000;
				setTimeout(function(){
					getdammingcheckresultAPI(props.shoppingStData.data.transactionno);
				}, dammingInterval);

			}else if(getdammingcheckresultData.data.dammingCheckResult === "1" || getdammingcheckresultData.data.dammingCheckResult === 1){ //OK
				goRegi();

			}else if(getdammingcheckresultData.data.dammingCheckResult === "2" || getdammingcheckresultData.data.dammingCheckResult === 2){ //チェック待ち
				const dammingInterval = dammingCheckRunInterval * 1000;
				setTimeout(function(){
					getdammingcheckresultAPI(props.shoppingStData.data.transactionno);
				}, dammingInterval);
			}

		}else{ //ERROR
			console.log(`【getdammingcheckresultAPI】 errorCode: ${getdammingcheckresultData.errorCode}`);
			console.log(`【getdammingcheckresultAPI】 errorMessage: ${getdammingcheckresultData.errorMessage}`);
			console.log(`【getdammingcheckresultAPI】 isSuccess: ${getdammingcheckresultData.isSuccess}`);


			if(getdammingcheckresultData.errorCode === "26"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${getdammingcheckresultData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
				// props.setErr([true,`${payreserveData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
				// console.log("エラー32：フロントチェックエラー");
				// props.setPage("error_32");
			}else if(getdammingcheckresultData.errorCode === "27"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${getdammingcheckresultData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
				// props.setErr([true,`${payreserveData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
				// console.log("エラー32：フロントチェックエラー");
				// props.setPage("error_32");
			}else if(getdammingcheckresultData.errorCode === "32"){//フロントチェックエラー
				// props.setErrFlg(true);
				// props.setErr([true,`${payreserveData.errorCode}`,`${payreserveData.errorMessage}`]);
				console.log("エラー32：フロントチェックエラー");
				props.setPage("error_32");
			}else{
				// props.setErrNum(`${payreserveData.errorCode}`);
				// props.setShowModal(true);
				// props.setErrTxt(`${payreserveData.errorMessage}`);
				props.setErrFlg(true);
				props.setErr([true,`${getdammingcheckresultData.errorCode}`,`${getdammingcheckresultData.errorMessage}`]);

				//有効
				// setTimeout(function(){
				// 	if(barcodeCapture){
				// 		// barcodeCapture.addListener(listener);
				// 		barcodeCapture.setEnabled(true);
				// 	}
				// }, 2200);
			}
		}
	}
	if(getdammingcheckresultError){
		console.log("getdammingcheckresultError");
		console.log(getdammingcheckresultError);
		props.setErrFlg(true);
		props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// console.log("タイムアウト（ノーレスポンス）・通信エラーのため、精算確認APIへ自動遷移");
	}
}, [getdammingcheckresultData,getdammingcheckresultLoading,getdammingcheckresultError]);


useEffect(() => {
	if(props.frontCheckRetry === true){
		const dammingInterval = dammingCheckRunInterval * 1000;
		setTimeout(function(){
			getdammingcheckresultAPI(props.shoppingStData.data.transactionno);
		}, dammingInterval);
		props.setFrontCheckRetry(false);
	}
}, [props.frontCheckRetry]);


return (
	<>
	<div id="regiFrame" className={styles.regiFrame}>
	<div id="checkoutBox" className={styles.checkoutBox}>

		<p className={styles.checkoutBox_tit}>レジにご案内します<br/>しばらくお待ちください</p>
		{/* <div id="front_check" className={styles.frontCheck}></div> */}
		<Lottie id="front_check" className={styles.frontCheck}
			options={defaultOptions}
			width={250}
			height={288}
			ref={lottieRef}
		>
		</Lottie>
		<p className={styles.frontCheck_txt}><span>従業員が商品点数を</span><span>確認させていただくことがございます</span></p>
	</div>
	</div>
	</>
)

}
